/**
 * The rail's two personal choices, kept on this device: collapsed to 64px, and the dark rail.
 * Storage can be refused (a private window), so a read falls back and a write is best-effort.
 */
import { create } from "zustand";

const COLLAPSED_KEY = "kapitan.sidebar.collapsed";
const DARK_KEY = "kapitan.sidebar.dark";

function read(key: string): boolean {
  try {
    return globalThis.localStorage.getItem(key) === "1";
  } catch {
    return false;
  }
}

function write(key: string, value: boolean): void {
  try {
    globalThis.localStorage.setItem(key, value ? "1" : "0");
  } catch {
    // The choice still holds for this tab; nothing to tell the person.
  }
}

interface ShellPrefs {
  collapsed: boolean;
  dark: boolean;
  setCollapsed: (next: boolean) => void;
  setDark: (next: boolean) => void;
}

export const useShellPrefs = create<ShellPrefs>((set) => ({
  collapsed: read(COLLAPSED_KEY),
  dark: read(DARK_KEY),
  setCollapsed: (next): void => {
    write(COLLAPSED_KEY, next);
    set({ collapsed: next });
  },
  setDark: (next): void => {
    write(DARK_KEY, next);
    set({ dark: next });
  },
}));
